import makeAbout from '@main/factories/pages/makeAbout';

export function Page() {
	return makeAbout();
}
